import { Icon } from '#/components/Icon/Icon';
import {
  LocationRadiusSelectChevronHolder,
  LocationRadiusSelectHolder,
  LocationRadiusSelectLeftIconHolder,
  LocationRadiusSelectStyled,
} from '#/components/LocationRadiusSelect/LocationRadiusSelect.styled';

type Props = {
  radius: string;
  options: { label: string; value: string }[];
  onChange: (newRadius: string) => void;
  disabled: boolean;
  qaId: string;
  fullWidth?: boolean;
};

export function LocationRadiusSelect({
  radius,
  options,
  onChange,
  disabled,
  qaId,
  fullWidth,
}: Props) {
  return (
    <LocationRadiusSelectHolder>
      <LocationRadiusSelectLeftIconHolder>
        <Icon name="bulls-eye" size={24} />
      </LocationRadiusSelectLeftIconHolder>

      <LocationRadiusSelectStyled
        value={radius}
        onChange={(event) => onChange(event.target.value)}
        disabled={disabled}
        $fullWidth={Boolean(fullWidth)}
        data-qa-id={qaId}
      >
        {options.map((option) => (
          <option key={option.value} value={option.value}>
            {option.label}
          </option>
        ))}
      </LocationRadiusSelectStyled>

      <LocationRadiusSelectChevronHolder>
        <Icon name="chevron-down" size={16} />
      </LocationRadiusSelectChevronHolder>
    </LocationRadiusSelectHolder>
  );
}
